(function () {
  if (window._qvmReady) return;
  window._qvmReady = true;

  /* ─── Open / Close ─── */
  window.qvmOpen = function (id) {
    var el = document.getElementById(id);
    if (!el) return;
    if (el.parentNode !== document.body) document.body.appendChild(el);
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    /* Force-load gallery images now the modal is visible. They render loading="lazy" to stay out of the initial page load (perf fix); flip to eager on open so the gallery is never blank. */
    el.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
    /* Reset gallery to slide 0 */
    var track = el.querySelector('.qvm-gallery__track');
    if (track) { track.style.transition = 'none'; track.style.transform = 'translateX(0)'; track._qvmIdx = 0; setTimeout(function(){ track.style.transition = ''; }, 50); }
    updateDots(id, 0);
    el.addEventListener('click', function onOverlay(e) {
      if (e.target === el) { qvmClose(id); el.removeEventListener('click', onOverlay); }
    });
  };

  window.qvmClose = function (id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    var btn = document.getElementById(id + '-atc-btn');
    if (btn) {
      btn._atcBusy = false;
      btn.classList.remove('qvm-atc-btn--loading', 'qvm-atc-btn--success');
      btn.disabled = false;
      var label = btn.querySelector('span');
      if (label) label.textContent = 'Add to Cart';
    }
  };

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = document.querySelector('.qvm-overlay[aria-hidden="false"]');
      if (open) qvmClose(open.id);
    }
  });

  /* ─── Gallery helpers ─── */
  function getSlides(modalId) {
    var track = document.getElementById(modalId + '-track');
    return track ? Array.from(track.querySelectorAll('.qvm-gallery__slide')) : [];
  }

  function updateDots(modalId, idx) {
    var dotsEl = document.getElementById(modalId + '-dots');
    if (!dotsEl) return;
    var dots = dotsEl.querySelectorAll('.qvm-dot');
    dots.forEach(function (d, i) { d.classList.toggle('qvm-dot--active', i === idx); });
  }

  function goToSlide(modalId, idx) {
    var track = document.getElementById(modalId + '-track');
    if (!track) return;
    var slides = track.querySelectorAll('.qvm-gallery__slide');
    if (!slides.length) return;
    idx = Math.max(0, Math.min(idx, slides.length - 1));
    var offset = 0;
    for (var j = 0; j < idx; j++) {
      offset += slides[j].offsetWidth + 8;
    }
    track.style.transform = 'translateX(-' + offset + 'px)';
    track._qvmIdx = idx;
    updateDots(modalId, idx);
  }

  function slideToMedia(modalId, mediaId) {
    var track = document.getElementById(modalId + '-track');
    if (!track) return;
    var slides = track.querySelectorAll('.qvm-gallery__slide');
    for (var i = 0; i < slides.length; i++) {
      var img = slides[i].querySelector('img');
      if (img && img.dataset.mediaId === String(mediaId)) {
        goToSlide(modalId, i);
        return;
      }
    }
  }

  /* ─── Swipe / drag for gallery ─── */
  document.addEventListener('DOMContentLoaded', function () { initGalleries(); });
  if (document.readyState !== 'loading') { initGalleries(); }

  var _galleriesInited = false;
  function initGalleries() {
    if (_galleriesInited) return;
    _galleriesInited = true;
    document.addEventListener('touchstart', onGalleryTouchStart, { passive: true });
    document.addEventListener('touchend',   onGalleryTouchEnd,   { passive: true });
    document.addEventListener('mousedown',  onGalleryMouseDown);
    document.addEventListener('mouseup',    onGalleryMouseUp);
  }

  var _swipe = {};
  function onGalleryTouchStart(e) {
    var gallery = e.target.closest('.qvm-gallery');
    if (!gallery) return;
    _swipe.startX = e.touches[0].clientX;
    _swipe.modalId = gallery.dataset.modalId;
  }
  function onGalleryTouchEnd(e) {
    if (!_swipe.modalId) return;
    var dx = e.changedTouches[0].clientX - _swipe.startX;
    if (Math.abs(dx) < 30) { _swipe = {}; return; }
    var track = document.getElementById(_swipe.modalId + '-track');
    var slides = track ? track.querySelectorAll('.qvm-gallery__slide') : [];
    var cur = (track && track._qvmIdx) || 0;
    if (dx < 0 && cur < slides.length - 1) goToSlide(_swipe.modalId, cur + 3);
    else if (dx > 0 && cur > 0)            goToSlide(_swipe.modalId, cur - 3);
    _swipe = {};
  }
  function onGalleryMouseDown(e) {
    var gallery = e.target.closest('.qvm-gallery');
    if (!gallery) return;
    _swipe.startX = e.clientX;
    _swipe.modalId = gallery.dataset.modalId;
    _swipe.mouse = true;
  }
  function onGalleryMouseUp(e) {
    if (!_swipe.mouse || !_swipe.modalId) return;
    var dx = e.clientX - _swipe.startX;
    if (Math.abs(dx) < 20) { _swipe = {}; return; }
    var track = document.getElementById(_swipe.modalId + '-track');
    var slides = track ? track.querySelectorAll('.qvm-gallery__slide') : [];
    var cur = (track && track._qvmIdx) || 0;
    if (dx < 0 && cur < slides.length - 1) goToSlide(_swipe.modalId, cur + 3);
    else if (dx > 0 && cur > 0)            goToSlide(_swipe.modalId, cur - 3);
    _swipe = {};
  }

  /* ─── Helpers ─── */
  function getVariants(modalId) {
    var el = document.getElementById(modalId + '-variants');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function getMediaMap(modalId) {
    var el = document.getElementById(modalId + '-media-map');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  }

  function getSelectedOptions(sheet) {
    return Array.from(sheet.querySelectorAll('.qvm-option-group')).map(function (g) {
      var sel = g.querySelector('.qvm-pill--selected');
      return sel ? sel.dataset.value : null;
    });
  }

  function updatePrice(modalId, variant) {
    if (!variant) return;
    var price   = Math.round(variant.price / 100);
    var compare = variant.compare_at_price ? Math.round(variant.compare_at_price / 100) : null;
    var onSale  = compare && compare > price;
    var offPct  = onSale ? Math.round((compare - price) / compare * 100) : 0;

    var hHtml = onSale
      ? '<span class="qvm-price__sale">&#8377;' + price + '</span>' +
        '<span class="qvm-price__compare">&#8377;' + compare + '</span>' +
        '<span class="qvm-price__off">' + offPct + '% OFF</span>'
      : '<span class="qvm-price__regular">&#8377;' + price + '</span>';
    var aHtml = onSale
      ? '<span class="qvm-atc-price__sale">&#8377;' + price + '</span>' +
        '<span class="qvm-atc-price__compare">&#8377;' + compare + '</span>' +
        '<span class="qvm-atc-price__off">' + offPct + '% OFF</span>'
      : '<span class="qvm-atc-price__regular">&#8377;' + price + '</span>';

    var pEl = document.getElementById(modalId + '-price');
    var aEl = document.getElementById(modalId + '-atc-price');
    if (pEl) pEl.innerHTML = hHtml;
    if (aEl) aEl.innerHTML = aHtml;
  }

  function filterSubsequentPills(sheet, modalId, changedIdx) {
    var variants     = getVariants(modalId);
    var groups       = sheet.querySelectorAll('.qvm-option-group');
    var selectedOpts = getSelectedOptions(sheet);
    for (var gi = changedIdx + 1; gi < groups.length; gi++) {
      groups[gi].querySelectorAll('.qvm-pill').forEach(function (pill) {
        var testOpts = selectedOpts.slice(0, gi).concat([pill.dataset.value]);
        var hasAny   = variants.some(function (v) {
          var vo = [v.option1, v.option2, v.option3].filter(Boolean);
          return testOpts.every(function (opt, i) { return vo[i] === opt; });
        });
        var hasAvail = variants.some(function (v) {
          var vo = [v.option1, v.option2, v.option3].filter(Boolean);
          return testOpts.every(function (opt, i) { return vo[i] === opt; }) && v.available;
        });
        pill.style.display = hasAny ? '' : 'none';
        pill.classList.toggle('qvm-pill--unavailable', hasAny && !hasAvail);
      });
    }
  }

  /* ─── Pill click ─── */
  document.addEventListener('click', function (e) {
    var pill = e.target.closest('.qvm-pill');
    if (!pill || pill.classList.contains('qvm-pill--unavailable')) return;
    var sheet   = pill.closest('.qvm-sheet');
    if (!sheet) return;
    var modalId = sheet.dataset.modalId;
    var optIdx  = parseInt(pill.dataset.optionIndex, 10);
    var value   = pill.dataset.value;

    sheet.querySelectorAll('.qvm-pill[data-option-index="' + optIdx + '"]').forEach(function (p) {
      p.classList.toggle('qvm-pill--selected', p === pill);
    });
    var lbl = document.getElementById(modalId + '-opt-val-' + optIdx);
    if (lbl) lbl.textContent = value;

    filterSubsequentPills(sheet, modalId, optIdx);

    /* Auto-select first valid pill in subsequent groups */
    var allGroups = sheet.querySelectorAll('.qvm-option-group');
    for (var gi = optIdx + 1; gi < allGroups.length; gi++) {
      var curSel    = allGroups[gi].querySelector('.qvm-pill--selected');
      var isInvalid = !curSel || curSel.style.display === 'none' || curSel.classList.contains('qvm-pill--unavailable');
      if (isInvalid) {
        var gPills    = allGroups[gi].querySelectorAll('.qvm-pill');
        var firstValid = null;
        for (var pi = 0; pi < gPills.length; pi++) {
          if (gPills[pi].style.display !== 'none' && !gPills[pi].classList.contains('qvm-pill--unavailable')) {
            firstValid = gPills[pi]; break;
          }
        }
        if (firstValid) {
          gPills.forEach(function (p) { p.classList.remove('qvm-pill--selected'); });
          firstValid.classList.add('qvm-pill--selected');
          var lbl2 = document.getElementById(modalId + '-opt-val-' + gi);
          if (lbl2) lbl2.textContent = firstValid.dataset.value;
          filterSubsequentPills(sheet, modalId, gi);
        }
      }
    }

    /* Match variant */
    var variants     = getVariants(modalId);
    var selectedOpts = getSelectedOptions(sheet);
    var match = null;
    for (var i = 0; i < variants.length; i++) {
      var v  = variants[i];
      var vo = [v.option1, v.option2, v.option3].filter(Boolean);
      if (selectedOpts.every(function (opt, j) { return opt === null || vo[j] === opt; })) {
        match = v; break;
      }
    }
    if (!match) return;

    var input = document.getElementById(modalId + '-variant-input');
    if (input) input.value = match.id;

    updatePrice(modalId, match);

    var btn = document.getElementById(modalId + '-atc-btn');
    if (btn) {
      btn.disabled = !match.available;
      var btnLabel = btn.querySelector('span');
      if (btnLabel) btnLabel.textContent = match.available ? 'Add to Cart' : 'Sold Out';
    }

    /* Swap gallery to variant image */
    if (match.featured_media) {
      slideToMedia(modalId, match.featured_media.id);
    }
  });

  /* ─── ATC — XHR (bypasses Shopflo's fetch patch) ─── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.qvm-atc-btn');
    if (!btn || btn.disabled || btn._atcBusy) return;

    var modalId   = btn.dataset.modalId;
    var prodId    = btn.dataset.productId;
    var prodTitle = btn.dataset.productTitle || '';
    var varInput  = document.getElementById(modalId + '-variant-input');
    if (!varInput || !varInput.value) return;
    var variantId = varInput.value;

    btn._atcBusy = true;
    btn.classList.add('qvm-atc-btn--loading');
    btn.disabled = true;
    var label = btn.querySelector('span');
    if (label) label.textContent = '';

    var spinner = document.createElement('span');
    spinner.className = 'qvm-btn-spinner';
    btn.appendChild(spinner);

    if (window.dataLayer) {
      window.dataLayer.push({ event: 'add_to_cart', item_id: prodId, item_name: prodTitle });
    }

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4) return;
      spinner.remove();

      if (xhr.status === 200) {
        btn.classList.remove('qvm-atc-btn--loading');
        btn.classList.add('qvm-atc-btn--success');
        if (label) label.textContent = '✓ Added!'; try { document.dispatchEvent(new CustomEvent('pt:cart-changed')); } catch (e) {}

        var cartXhr = new XMLHttpRequest();
        cartXhr.open('GET', '/cart.js', true);
        cartXhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        cartXhr.onreadystatechange = function () {
          if (cartXhr.readyState !== 4 || cartXhr.status !== 200) return;
          try {
            var cart  = JSON.parse(cartXhr.responseText);
            var count = cart.item_count || 0;
            var cartIcon = document.getElementById('flo-cart-icon');
            if (!cartIcon) return;
            var bubble = cartIcon.querySelector('.flo-cart-icon-bubble') ||
                         cartIcon.querySelector('.cart-count-bubble');
            if (!bubble) {
              bubble = document.createElement('div');
              bubble.className = 'cart-count-bubble flo-cart-icon-bubble';
              cartIcon.appendChild(bubble);
            }
            bubble.innerHTML =
              '<span aria-hidden="true">' + (count < 100 ? count : '99+') + '</span>' +
              '<span class="visually-hidden">' + count + ' items</span>';
            bubble.style.display = count > 0 ? '' : 'none';
          } catch (err) {}
        };
        cartXhr.send();

        setTimeout(function () { qvmClose(modalId); }, 800);

      } else {
        btn.classList.remove('qvm-atc-btn--loading');
        btn._atcBusy = false;
        btn.disabled = false;
        if (label) label.textContent = 'Add to Cart';
        try {
          var errData = JSON.parse(xhr.responseText);
          alert(errData.description || errData.message || 'Could not add to cart. Please try again.');
        } catch (ex) {
          alert('Could not add to cart. Please try again.');
        }
      }
    };
    xhr.send(JSON.stringify({ id: variantId, quantity: 1 }));
  });

})();